import React from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // Import BrowserRouter and Link

const CommunityPricingHome = () => {
    const codes = {
        'PWU Starter Club – 1,25,000 BDT (One-Time Payment | Non-Refundable)': {
            originalPrice: '10,00,000',
            offerPrice: '1,25,000 BDT',
            topics: [
                '12 Months Full Access to the PWU Premium Content Section Worth 20000+ BDT',
                '1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value)',
                '12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 600000+ BDT',
                '1 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 100000+ BDT',
                '12 Months Group Mentorship for ongoing guidance and support',
                'Launch Code Training Access to master your business launch and marketing Worth 100000+ BDT',
            ],
        },
        'PWU Rich Club – 12,00,000+ BDT (One-Time Payment | Non-Refundable)': {
            originalPrice: '450,00,000 BDT',
            offerPrice: '12,00,000 BDT',
            topics: [
                '12 Months Full Access to the PWU Premium Content Section Worth 20000+ BDT,',
                '1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value),',
                '12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 600000+ BDT,',
                '2 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 200000+ BDT,',
                '12 Months Group Mentorship for ongoing guidance and support,',
                'One to One Exclusive Mentorship Support from Jahid for 12 months Worth 3000000+ BDT,',
                'Launch Code Training Access to master your business launch and marketing Worth 100000+ BDT,',
                'Business Partnership Opportunity for 3 Years & Expected Financial Return 270000 BDT - 540000 BDT,',
            ],
        },
        'PWU Elite Club – 30,00,000+ BDT (One-Time Payment | Non-Refundable)': {
            originalPrice: '55,00,000 BDT',
            offerPrice: '30,00,000 BDT',
            topics: [
                '12 Months Full Access to the PWU Premium Content Section Worth 20000+ BDT,',
                '1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value),',
                '12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 600000+ BDT,',
                '3 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 300000+ BDT,',
                '12 Months Group Mentorship for ongoing guidance and support,',
                'One to One Exclusive Mentorship Support from Jahid for 12 months Worth 3000000+ BDT,',
                'Launch Code Training Access to master your business launch and marketing Worth 100000+ BDT,',
                'Growth Code Training Access to set up your business sales system, marketing funnel and Establishing Authority Brand Positioning Worth 300000+ BDT,',
                'Business Partnership Opportunity for 5 Years & Expected Financial Return 675000 BDT - 1350000 BDT,',
            ],
        },
        'PWU Capital Club – 12+ Million BDT (One-Time Payment | Non-Refundable)': {
            originalPrice: '100,000,000 BDT',
            offerPrice: '12,000,000 BDT',
            topics: [
                '10 years Full Access to the PWU Premium Content Section, Worth 250000+,',
                '10 years Community Membership with like-minded entrepreneurs and experts worth 1000000+,',
                '10 years Group Live Sessions (online/offline) with Jahid Hasan & guest mentors (Unlimited Value),',
                'At least 40 Personalized Strategy Audits over 10 years to review and upgrade your Life, Business & Income roadmap, worth 6000000+ BDT,',
                '10 years Group Mentorship for ongoing guidance and support,',
                '10 years One to One Exclusive Mentorship Support from Jahid (Unlimited Value),',
                '10 years Access to All Flagship Training Programme of PWU to master your Life, Business & Income Development (Unlimited Value),',
                'Business Partnership Opportunity for 10 Years & Expected Financial Return 9000000 BDT - 18000000 BDT,',
            ],
        },
    };

    const boxStyle = {
        width: '100%',
        maxWidth: '400px',
        padding: '20px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
    };


    // Renamed from buttonStyle to linkStyle for clarity and consistency
    const linkStyle = {
        display: 'inline-block',
        marginTop: '20px',
        padding: '10px 20px',
        backgroundColor: 'purple',
        color: 'white',
        borderRadius: '6px',
        textDecoration: 'none', // Important for Link component
        fontSize: '16px',
        textAlign: 'center',
        border: 'none', // Remove any default button border
    };

    // Helper function to extract number from offerPrice string
    const extractAmount = (priceStr) => {
        // Remove non-numeric characters (keep dot if you want decimals)
        const numericStr = priceStr.replace(/[^\d.]/g, '');
        return parseFloat(numericStr) || 0;
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
            {Object.entries(codes).map(([codeTitle, { originalPrice, offerPrice, topics }]) => (
                <div key={codeTitle} style={boxStyle}>
                    <div className=''>
                        <h4 style={{  marginBottom: '10px' }} className='text-center'>{codeTitle}</h4>
                        <ol style={{ paddingLeft: '20px', color: '#f8f9fa' }}> {/* Added color for dark mode readability */}
                            {topics.map((topic, idx) => (
                                <li key={idx} style={{ marginBottom: '8px' }}>{topic}</li>
                            ))}
                        </ol>
                    </div>
                    <div style={{ marginTop: 'auto' }} className='text-center'>
                        <h4 style={{ margin: '20px 0 10px 0' }}>
                            Total Value: <del style={{ color: 'gray', marginRight: '10px' }}>{originalPrice}</del><br />
                            Join Now: <span style={{ color: 'green', fontWeight: 'bold' }}>{offerPrice}</span> {/* Adjusted color for dark mode */}
                        </h4>
                        <div className='text-center'>
                            <Link
                                className="btn-default"
                                to={`/order?service=Community&package=${encodeURIComponent(codeTitle.split(' – ')[0])}&amount=${extractAmount(offerPrice)}`}
                            >
                                Purchase Now
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CommunityPricingHome;
